import React from 'react'
import { useDispatch } from 'react-redux'
import { setDrawer } from 'slices/drawer'
import { STATICS } from 'statics'
import { DRAWER_KEY, EVENT_STATUS, FIREBASE_EVENTS } from 'app-constants'
import { useFirebaseEvent } from 'hooks'
import { BaseCard } from '../base-card'

export function VirtualSupportCard() {
  const dispatch = useDispatch()
  const { sendEvent } = useFirebaseEvent()

  function handleClick() {
    sendEvent(FIREBASE_EVENTS.CLICK_ON_VIRTUAL_SUPPORT, EVENT_STATUS.SUCCESS)
    dispatch(setDrawer(DRAWER_KEY.VIRTUAL_SUPPORT))
  }

  return <BaseCard onClick={handleClick} text='Suporte técnico' icon={<STATICS.WIFI />} />
}
